import { useEffect, useRef } from "react";

const BackgroundVideo = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;

    const attemptPlay = () => {
      const p = v.play();
      if (p && typeof p.catch === "function") p.catch(() => { /* ignore */ });
    };

    // Try immediately (in case autoplay was blocked)
    attemptPlay();

    // Resume if the browser pauses it (tab visibility, low-power, etc.)
    const onPause = () => attemptPlay();
    const onEnded = () => {
      try { v.currentTime = 0; } catch (_e) { /* noop */ }
      attemptPlay();
    };
    const onVisibility = () => { if (!document.hidden) attemptPlay(); };

    v.addEventListener("pause", onPause);
    v.addEventListener("ended", onEnded);
    document.addEventListener("visibilitychange", onVisibility);

    // Safety net: check every 5s
    const id = setInterval(() => {
      if (v.paused || v.ended) attemptPlay();
    }, 5000);

    return () => {
      v.removeEventListener("pause", onPause);
      v.removeEventListener("ended", onEnded);
      document.removeEventListener("visibilitychange", onVisibility);
      clearInterval(id);
    };
  }, []);

  return (
    <div
      aria-hidden="true"
      data-testid="app-background-video"
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
    >
      <video
        ref={videoRef}
        className="h-full w-full object-cover"
        style={{ opacity: 0.85 }}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        disablePictureInPicture
        key="bbm-bg-video-v3"
      >
        <source src="/media/bg.mp4?v=3" type="video/mp4" />
      </video>
      {/* Light readability tint — kept low so the video stays prevalent */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(5,5,5,0.35) 0%, rgba(5,5,5,0.15) 30%, rgba(5,5,5,0.15) 70%, rgba(5,5,5,0.55) 100%)",
        }}
      />
    </div>
  );
};

export default BackgroundVideo;
